import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { CourseComponentConfig, courseComponentConfigInput } from "./component/CourseComponentConfig";

@Form({title: "Entries Config"})
export class EntriesConfig {

	@Input({type: InputType.CHECKBOX, title: "Enable Refine"})
	public enableRefine?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Load More"})
	public enableLoadMore?: boolean;

	@Input({type: InputType.NUMBER, title: "Default Page Size"})
	public pageSize?: number;

	@Input({type: courseComponentConfigInput, title: "Course Display Settings"})
	public courseConfig?: CourseComponentConfig;

}



// WEBPACK FOOTER //
// ./src/panels/bundleEntries/EntriesConfig.ts